<small class="debug">{{me}}</small>
<div [@fadeIn]="getState()">
  <router-outlet></router-outlet>
</div>

